import { Skeleton } from '@monksflow/monks-ui';
import { MonksFlowIsotype } from '@/shared/ui/MonksFlowIsotype';
import { StaggerItem } from '@/shared/ui/animations';
import { useTranslation } from 'react-i18next';

interface GreetingV2Props {
  /** User's name for the greeting. When undefined, renders a skeleton loader. */
  userName: string | undefined;
}

const getGreetingKey = () => {
  const hour = new Date().getHours();
  if (hour < 12) return 'dashboard.greetingV2.goodMorning' as const;
  if (hour < 18) return 'dashboard.greetingV2.goodAfternoon' as const;
  return 'dashboard.greetingV2.goodEvening' as const;
};

export const GreetingV2 = ({ userName }: GreetingV2Props) => {
  const { t } = useTranslation('springboard');

  return (
    <div className="content-block w-1/2 min-w-0 shrink justify-between gap-section">
      <div className="h-4.5 w-9.5 shrink-0 text-foreground">
        <MonksFlowIsotype
          className="h-full w-full"
          title={t('dashboard.greetingV2.monksFlowLogo')}
        />
      </div>

      {/* The design's 42px/-0.05em/40px sits between the type ramp's rungs, and
          the exact values were chosen deliberately for this headline, so it
          overrides `type-display-md` rather than snapping to `display-md`. */}
      {userName ? (
        <StaggerItem index={0}>
          <p className="type-display-md text-[42px] leading-10 tracking-[-0.05em] text-foreground">
            {t('dashboard.greetingV2.greetingLine', { greeting: t(getGreetingKey()), userName })}
          </p>
        </StaggerItem>
      ) : (
        <Skeleton className="h-10 w-100" />
      )}
    </div>
  );
};
